import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'feedback-'

export default {
  path: '/feedback',
  name: 'feedback',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '用户反馈',
      },
      component: () => import('@/views/feedback/list'),
    },
  ],
}
